class AppError extends Error {
    public code: string;
    public type: ErrorType;
    public name: string;
    public message: string;

    constructor(code: string, type: ErrorType, message: string) {
        super();
        this.code = code;
        this.type = type;
        this.name = type;
        this.message = message;
        // 下記がないとinstanceof で判断ができない
        // https://stackoverflow.com/questions/31626231/custom-error-class-in-typescript/41429145#41429145
        // https://github.com/microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, AppError.prototype);
    }

    public toString() {
        return `${this.name}:${this.message}`;
    }
}

enum ErrorType {
    // 一般的なクライアントリクエスト起因エラー
    API_REQUEST_400 = "BadRequest 400",
    // 一般的な認証エラー
    API_REQUEST_401 = "Unauthorized 401",
    // 一般的な権限エラー
    API_REQUEST_403 = "Forbidden 403",
    // 一般的な存在しないリソース参照エラー
    API_REQUEST_404 = "NotFound 404",
    // 一般的なコンフリクトエラー
    API_REQUEST_409 = "AlreadyExists 409",
    // 一般的な内部エラー
    API_REQUEST_500 = "Internal ErrorType 500",
    // サービス利用不可
    API_REQUEST_503 = "Service Unavailable 503",

    // フロントエンドのエラー
    CLIENT_ERROR = "Error",
    CLIENT_FETCH_ERROR = "Client Fetch Error",
    TOKEN_ERROR = "Token Error",
    // 特殊 project 関連の制限時のエラー
    FAIL_PROJECT_CREATE = "Fail Project Create",
    FAIL_PROJECT_OPEN = "Fail Project Open",
    // 特殊 scout 関連の制限時のエラー
    FAIL_CUSTOMER_SCOUT = "Fail Customer Scout",
    // 特殊 member 関連の制限時のエラー
    FAIL_CLIENT_MEMBER_CREATE = "Fail Client Member Create",
    FAIL_APPLY_CLIENT_EMAIL_ALREADY_USED = "Fail Apply Client Email Already Used",

    FAIL_PAY_JP = "fail pay jp error",

    // Firebaseのエラー
    FIREBASE_AUTH_ERROR = "Auth Error",

    // 未定義のエラー
    UNKNOWN = 'UNKNOWN ERROR',

}

export {AppError, ErrorType};



// WEBPACK FOOTER //
// ./src/domain/model/app_error.ts